/**
 * CollectionIcon — maps a HelpCollection's `iconKey` to the lucide component.
 * Single source of truth for these icons: used both by the full-page Knowledge
 * Center topic cards and by the compact in-widget Help tab's topic tiles.
 */

import type { LucideIcon } from 'lucide-react';
import { Compass, Users, Activity, ShieldCheck, BarChart3, Building2 } from 'lucide-react';
import type { HelpCollectionIcon } from '../SupportWidget/help/helpContent';

const ICONS: Record<HelpCollectionIcon, LucideIcon> = {
  // Orientation, not launch. A rocket implies speed; new users need direction.
  'getting-started': Compass,
  clients: Users,
  'clinical-workflows': Activity,
  account: ShieldCheck,
  // The Red Dot report is bar/column based, not a trend line.
  insights: BarChart3,
  'organization-setup': Building2,
};

export interface CollectionIconProps {
  iconKey: HelpCollectionIcon;
  size?: number;
}

export function CollectionIcon({ iconKey, size = 19 }: CollectionIconProps) {
  const Icon = ICONS[iconKey];
  return <Icon size={size} aria-hidden="true" />;
}

export default CollectionIcon;
